import { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { GridColDef, GridRowParams, GridValueGetterParams, MuiEvent } from '@mui/x-data-grid';
import { createTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import axios from "axios";
import { useForm, Resolver, Controller, SubmitHandler } from "react-hook-form";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import EmailIcon from '@mui/icons-material/Email';
import Link from '@mui/material/Link';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { alpha, styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import ConfirmDialog, { confirmDialog } from "../../components/ConfirmDialog";
import { setPageTitle } from "../../slices/applicationSlice";
import { IApplication } from "../../interfaces/IApplication";
import {  useAppDispatch } from "../../hooks";
import { ITraining } from "../../interfaces/Growing/ITraining";
import SprayIcon from '@mui/icons-material/Opacity';

import MixIcon from '@mui/icons-material/Science';
import ActionButton from "../../components/ActionButton";
import ActionMenu from "../../components/ActionMenu";

const handleSubmitD = () => console.log('Okay')

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[300],
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity,
      ),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
          theme.palette.action.selectedOpacity +
          theme.palette.action.hoverOpacity,
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
}));




const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

type Anchor = 'top' | 'left' | 'bottom' | 'right';

interface IFormInput {
  Name: string
  Type: string
  Crew: string
}


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Training() {

  function SprayClicked(_event: React.MouseEvent<HTMLElement>): void {
      
    setTrainingOpen(true);
  }

  function MixClicked(_event: React.MouseEvent<HTMLElement>): void {
      
    setTrainingOpen(true);
  }

 

  function handleClose() {
    setTrainingOpen(!trainingOpen);
  }

  const buttons = [
    <ActionButton action={SprayClicked} buttonLabel="ADD SPRAY TRAINING" />,
    <ActionButton action={MixClicked} buttonLabel="ADD MIX TRAINING" />,
  ];

  const dispatch = useAppDispatch();
  const [helpOpen, setHelpOpen] = React.useState(false);
  const [trainingOpen, setTrainingOpen] = React.useState(false);
  const [type, setType] = React.useState("");
  const [trainingId, setTrainingId] = useState(0);
  const [selectedTraining, setSelectedTraining] = useState<ITraining>();
  useEffect(() => {
    let appState: IApplication = {
      pageTitle: "Training",
      backgroundPath: "/assets/images/growing.jpg"
    }
    dispatch(setPageTitle(appState));
  }, []);

  const [tabValue, setTabValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const [trainings, setTrainings] = useState<ITraining[]>([]);
  const [sprayTrainings, setSprayTrainings] = useState<ITraining[]>([]);
  const [mixTrainings, setMixTrainings] = useState<ITraining[]>([]);

  useEffect(() => {
    axios
      .get<ITraining[]>(`${process.env.REACT_APP_ENDPOINT}/api/Trainings`)
      .then(res => {
        setTrainings(res.data);
        console.log(res.data);
      })
  }, [trainingOpen]);



  const { register, handleSubmit, control, formState: { errors }, reset, getValues, setValue } = useForm<ITraining>({
    defaultValues: {
      id: 0
    }
  });

  const onSubmit: SubmitHandler<ITraining> = data => {
    console.log("IN SUBMIT");
    console.log(data);
    data.createdAt = new Date();
    data.updatedAt = new Date();
    if (data.id == 0) {
      data.id = 0;
      data.type = type;
      axios.post(`${process.env.REACT_APP_ENDPOINT}/api/Trainings`, data).then((data) => {
        if (data.status === 200) {
          setTrainingOpen(false);
        };
      });
    } else {
      axios.put(`${process.env.REACT_APP_ENDPOINT}/api/Trainings/${data.id}`, data).then((data) => {
        if (data.status === 200) {
          setTrainingOpen(false);
        };
      });
    }
   
  };

  const handleClickHelpOpen = () => {
    setHelpOpen(true);
  };

  const handleHelpClose = () => {
    setHelpOpen(false);
  };

  const handleTrainingOpen = (type: string) => {
    setValue('id', 0)
    setType(type);
    setTrainingOpen(true);
  };

  const handleTrainingClose = () => {
    setTrainingOpen(false);
    reset({})
  };


  const columnTraining: GridColDef[] = [
    { field: 'name', headerName: 'Chemical Name', width: 300 },
    { field: 'chemical', headerName: 'Title', width: 350 },
    { field: 'pdf', headerName: 'PDF', width: 200 },
    { field: 'video', headerName: 'Video Link', width: 400, },
  ];

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#010101' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
  }));

  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#89B219',
      },
    },
  });

  const handleDoubleClick = (x: GridRowParams<any>, y: MuiEvent<React.MouseEvent<HTMLElement, MouseEvent>>) => {
    console.log("double click");
    setTrainingId(x.row.id);
    setSelectedTraining(trainings.find(t => t.id == x.row.id))
    setTrainingOpen(true);
    console.log(getValues('id'))
  }

  useEffect(() => {
    reset(selectedTraining);
  }, [selectedTraining])

  useEffect(() => {
    setSprayTrainings(trainings.filter(x => x.type == 'spray'))
    setMixTrainings(trainings.filter(x => x.type == 'mix'))

    console.log(sprayTrainings);
    console.log(mixTrainings);
  }, [trainings])



  return (

    <div>
      <ActionMenu buttons={buttons}/>
      <Grid container spacing={0} bgcolor="#FFF" >

        <Grid item xs={12} >
          <Box sx={{ width: '100%', padding: '0' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={tabValue} onChange={handleChange} aria-label="basic tabs example" >
                <Tab label="How to Spray" {...a11yProps(0)} icon={<SprayIcon />} iconPosition="start" sx={{ fontSize: '1.5em', fontWeight: '700', letterSpacing: '0' }}  />
                <Tab label="How to Mix" {...a11yProps(1)} icon={<MixIcon />} iconPosition="start" sx={{ fontSize: '1.5em', fontWeight: '700', letterSpacing: '0' }}  />
              </Tabs>
            </Box>
            <TabPanel value={tabValue} index={0}>
              <Grid item xs={12}>
                <Item sx={{ padding: "0px" }}>
                  <div style={{ height: 'calc(100vh - 158px)', width: '100%' }}>
                    <StripedDataGrid
                      rows={sprayTrainings}
                      columns={columnTraining}
                      pageSize={20}
                      rowsPerPageOptions={[20]}
                      sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                      onRowDoubleClick={(x, y) => handleDoubleClick(x, y)}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                      }
                    />
                  </div>
                </Item>
              </Grid>
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              <Grid item xs={12}>
                <Item sx={{ padding: "0px" }}>
                  <div style={{ height: 'calc(100vh - 158px)', width: '100%' }}>
                    <StripedDataGrid
                      rows={mixTrainings}
                      columns={columnTraining}
                      pageSize={20}
                      rowsPerPageOptions={[20]}
                      sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                      onRowDoubleClick={(x, y) => handleDoubleClick(x, y)}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                      }
                    />
                  </div>
                </Item>
              </Grid>
            </TabPanel>
          </Box>
        </Grid>

      </Grid>
        <div>
          <BootstrapDialog
            onClose={handleHelpClose}
            aria-labelledby="customized-dialog-title"
            open={helpOpen}
          >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={handleHelpClose}>
              Need Support?
            </BootstrapDialogTitle>
            <DialogContent dividers>
              <Typography sx={{ mb: 3 }} variant="body2" gutterBottom>
                If you are having issues or have questions, please contact us below.
              </Typography>
              <Button size='large' fullWidth variant="contained" startIcon={<SmartphoneIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
                <Link href="tel:8003141797" underline="none" color="#FFF"><Typography variant='h6' fontWeight={700}>800-314-1797</Typography></Link>
              </Button>
              <Button size='large' fullWidth variant="contained" startIcon={<EmailIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
                <Link href="mailto:bobsmarket@idatp.com" underline="none">
                  <Typography variant='h6' fontWeight={700} color="#FFF">support@idatp.com</Typography></Link>
              </Button>
            </DialogContent>
          </BootstrapDialog>
        </div>

      <Dialog open={trainingOpen} onClose={handleTrainingClose} maxWidth='md' fullWidth>
        <DialogTitle>Add Mix Training</DialogTitle>
        <Box component="form">
          <TextField type="number" sx={{ display: "none" }} {...register('id')}></TextField>
          <DialogContent>
            <Item>
              <TextField
                required
                variant="filled"
                fullWidth
                id="chemicalname"
                label="Chemical Name"
                {...register("chemical")} />
            </Item>
            <Item>
              <TextField
                required
                variant="filled"
                fullWidth
                id="chemicaltitle"
                label="Title"
                {...register("name")} />
            </Item>
            <Item>
              <TextField
                required
                variant="filled"
                fullWidth
                id="chemicalpdf"
                label="PDF"
                {...register("pdf")} />
            </Item>
            <Item>
              <TextField
                required
                variant="filled"
                fullWidth
                id="chemicalvideo"
                label="Video"
                {...register("video")} />
            </Item>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleTrainingClose}>Cancel</Button>
            {getValues("id")
              ? <Button variant="contained" color="success" onClick={() => confirmDialog("Are you sure you want to add this training", handleSubmit(onSubmit))}>UPDATE Training</Button>
              : <Button variant="contained" color="success" onClick={() => confirmDialog("Are you sure you want to add this training", handleSubmit(onSubmit))}>CREATE Training</Button>
            }
            
          </DialogActions>
          <ConfirmDialog />
        </Box>
      </Dialog>

    </div>


  );
}

const patchingWeeks = [
  { label: 'Week One', type: 'week_one' },
  { label: 'Week Two', type: 'week_two' },
  { label: 'Week Three', type: 'week_three' },
  { label: 'Week Four', type: 'week_four' },
];

interface IPatchingListType {
  label: string;
  type: string;
}

const patchingListTypes = [
  { label: 'Generation 1', value: 'gen_one' },
  { label: 'Generation 2', value: 'gen_two' },
  { label: 'Manual', value: 'manual' },
  { label: 'Blow Out', value: 'blow_out' },
];

const crews = [
  { label: 'Crew A', value: '1' },
  { label: 'Crew B', value: '2' },
  { label: 'Crew C', value: '3' },
  { label: 'Crew D', value: '4' },
];

const marks = [
  {
    value: 0,
    label: 'WK1',
  },
  {
    value: 5,
    label: 'WK2',
  },
  {
    value: 10,
    label: 'WK3',
  },
  {
    value: 15,
    label: 'WK4',
  },
];
